import * as Schema from "effect/Schema";

import { AssetSha256 } from "../ids.js";

/**
 * ImageWidget — references an asset by content-addressed sha256. The
 * actual bytes live in the `builder-assets` garage bucket; we don't
 * commit asset blobs to git.
 *
 * A slot that has no asset yet publishes as `placeholder: "brand"` instead
 * of being dropped: the renderer draws on-brand generated art
 * (theme-engine `placeholderArt`) seeded by `seed`, so a template's image
 * slots look intentional until the author uploads their own picture.
 * Exactly one of `asset` / `placeholder` is meaningful; `asset` wins.
 */
export const ImageWidgetContent = Schema.Struct({
  contentType: Schema.Literal("image"),
  asset: Schema.optional(AssetSha256),
  placeholder: Schema.optional(Schema.Literal("brand")),
  /** Composition seed for the placeholder art (the widget id). */
  seed: Schema.optional(Schema.String),
  alt: Schema.optional(Schema.String),
  caption: Schema.optional(Schema.String),
  /** Crop-by-pan framing: CSS object-position ("x% y%"). Absent = "50% 50%". */
  objectPosition: Schema.optional(Schema.String),
});
export type ImageWidgetContent = Schema.Schema.Type<typeof ImageWidgetContent>;
